import { apiClient } from './apiClient';

export const TON_GIAO_API_END_POINT = "ton-giao";

export const tonGiaoApi = {
    // Lấy tất cả tôn giáo
    selectAll: () => apiClient.get(`${TON_GIAO_API_END_POINT}`),
};
